import React from 'react';
var ThemeContext = React.createContext(undefined);
export var ThemeContextProvider = ThemeContext.Provider;
export var ThemeContextConsumer = ThemeContext.Consumer;
